<template>
  <div class="search-page">
    <!-- 搜索区域 -->
    <div class="search-container">
      <div class="search-type-toggle">
        <v-btn-toggle v-model="searchType" mandatory class="button-group">
          <v-btn value="image" class="toggle-button" variant="text">搜图</v-btn>
          <v-btn value="contract" class="toggle-button" variant="text">按合同</v-btn>
          <v-btn value="product" class="toggle-button" variant="text">按产品</v-btn>
        </v-btn-toggle>
      </div>
      <v-text-field v-if="searchType !== 'image'"
        v-model="searchValue"
        :placeholder="searchType === 'contract' ? '请输入合同号或专案号或唯一码' : '请输入产品编号或唯一码'"
        variant="outlined"
        hide-details
        density="comfortable"
        class="search-input"
        @keyup.enter="handleBtnSearch"
      > 
        <template v-slot:append>
          <!-- <img v-if="searchType === 'product'" src="@/assets/searchImg.png" alt="search" style="width: 24px; height: 20px;cursor: pointer;" @click="handleSearchImg"> -->
          <v-btn
            icon="mdi-magnify"
            variant="text"
            @click="handleBtnSearch"
          />
        </template>
      </v-text-field>
      <div v-if="searchType === 'image'">
        <div class="search-img-area">
          <div class="d-flex align-center" style="color: #ffffff;font-size: 20px;">
            <img src="@/assets/uploadLogo.png" alt="upload" style="height: 32px;margin-right: 20px;cursor: pointer;" @click="handleSearchImg">
            请按类型上传图片进行搜索
          </div>
          <!-- <img v-if="searchType === 'product'" src="@/assets/searchImg.png" alt="search" style="width: 24px; height: 20px;cursor: pointer;" @click="handleSearchImg"> -->
          <div>
            <v-btn
              color="primary"
              variant="flat"
              @click="handleSearchImg('1')"
              style="margin-right: 20px;border: 1px solid #FFFFFF!important;box-shadow: 0 2px 4px rgba(255, 255, 255, 0.02) !important;color: #fff !important;border-radius: 4px;cursor: pointer;box-sizing: border-box;background: transparent !important;"
            >
              上传图纸
            </v-btn>

            <v-btn
              color="primary"
              variant="flat"
              @click="handleSearchImg('0')"
            >
              上传产品图
            </v-btn>
          </div>
        </div>
      </div>
    </div>

    <!-- 加载提示 -->
    <div v-if="isLoading" class="loading-container">
      <v-progress-circular indeterminate />
    </div>

    <!-- 错误提示 -->
    <v-alert
      v-if="error"
      type="error"
      variant="tonal"
      closable
      class="error-alert"
      @click:close="error = null"
    >
      {{ error }}
    </v-alert>

    <!-- 图片搜索组件 -->
    <div class="search-img-container" v-if="searchType === 'image'">
      <template v-if="searchImgList.length === 0">
        <div class="text-center empty-state">
          <v-icon icon="mdi-file-search-outline" size="64" class="mb-4" />
          <div class="text-h6">未找到相关图片</div>
          <div class="text-subtitle-1">请尝试其他搜索</div>
        </div>
      </template>
      <template v-if="searchImgList.length">
        <div class="clearfix">
          <div class="search-img-item float-left">
            <img :src="searchImg" alt="searchImg">
          </div>
          <div @click="handleSearchImgItem(item)" class="search-img-item float-left" v-for="item in searchImgList" :key="item.id">
            <img :src="item.url" alt="searchImg">
            <div class="search-img-item-label">相似度{{ item.score * 100 }}%</div>
          </div>
        </div>
      </template>
    </div>
    <v-dialog  
      v-model="showImageSearch"
      max-width="500"
    >
      <ImageSearchUpload
        @search="handleImageSearchResults"
        @selectProduct="handleSelectProduct"
      />
    </v-dialog>
    <!-- <v-dialog v-model="isLoadingImgSearch">
      <v-card>
        <v-card-title>
          <span>正在搜索...</span>
        </v-card-title>
      </v-card> 
    </v-dialog> -->
    <!-- 搜索结果表格 -->
    <v-data-table
      v-if="hasSearched && searchResults.length > 0 && searchType !== 'image'"
      :headers="tableHeaders"
      :items="searchResults"
      :loading="isLoading"
      hover
      class="search-table "
      :items-per-page-text="'每页项目数'"
      :pagination-icon-props="{
        variant: 'tonal',
        icon: true,
        size: 'small'
      }"
      v-model:page="currentPage"
      v-model:items-per-page="itemsPerPage"
      @update:options="savePageState"
    >
      <template #[`item.actions`]="{ item }">
        <div class="d-flex gap-2 justify-center">
          <template v-if="searchType === 'product'">
            <v-btn
              variant="flat"
              size="small"
              @click="handleViewDrawings(item)"
              prepend-icon="mdi-file-document-outline"
              class="action-btn"
            >
              查看图纸
            </v-btn>
          </template>
          <template v-else>
            <v-btn
              variant="flat"
              size="small"
              @click="toAllDraws(item)"
              prepend-icon="mdi-file-document-outline"
              class="action-btn"
            >
              <!-- :to="{
                path: `/contract/${item.id}/contract-draws`
              }" -->
              所有
            </v-btn>
            <v-btn
              variant="flat"
              size="small"
              @click="toOtherDraws(item)"
              prepend-icon="mdi-file-document-outline"
              class="action-btn"
            >
            <!-- :to="{
                path: `/contract/${item.id}/inventory`
              }" -->
              其他
            </v-btn>
            <v-btn
              variant="flat"
              size="small"
              @click="handleViewProducts(item)"
              prepend-icon="mdi-image-outline"
              class="action-btn"
            >
              产品
            </v-btn>
          </template>
        </div>
      </template>

      <template #no-data>
        <div class="empty-state" v-if="searchType !== 'image'">
          <v-icon icon="mdi-file-search-outline" size="64" class="mb-4" />
          <div class="text-h6">未找到相关{{ searchType === 'product' ? '产品' : '合同' }}</div>
          <div class="text-subtitle-1">请尝试其他搜索关键词</div>
        </div>
      </template>
    </v-data-table>

    <!-- 无数据提示 -->
    <div v-else-if="searchResults.length === 0 && searchImg === '' && !isLoading && searchType !== 'image'" class="empty-state">
      <v-icon icon="mdi-file-search-outline" size="64" class="mb-4" />
      <div class="text-h6">暂无数据</div>
      <div class="text-subtitle-1">请尝试其他搜索关键词</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted, watch } from 'vue'
import { useRouter, useRoute, onBeforeRouteLeave } from 'vue-router'
import { searchApi, contractApi } from '@/services/api'
import type { OrderData } from '@/types'
import ImageSearchUpload from '@/components/ImageSearchUpload.vue'
import { useSnackbar } from '@/composables/useSnackbar'

const router = useRouter()
const route = useRoute()

const { showSuccess, showError } = useSnackbar()
// 状态
const searchValue = ref('')
const isLoading = ref(false)
const error = ref<string | null>(null)
const contractResults = ref<any[]>([])
const productResults = ref<any[]>([])
const hasSearched = ref(false)
const searchType = ref<'contract' | 'product' | 'image'>('product')
const currentPage = ref(1)
const itemsPerPage = ref(10)
const searchImgType = ref('0')

const searchImg = ref('')
const isLoadingImgSearch = ref(false)
const searchImgList = ref<any[]>([])
// 从缓存恢复状态
const restoreFromCache = () => {
  const cacheData = localStorage.getItem('searchCache')
  if(localStorage.getItem('searchImgList')) {
    localStorage.removeItem('searchCache')
    return
  }
  if (cacheData) {
    const data = JSON.parse(cacheData)
    searchType.value = data.searchType
    searchValue.value = data.searchValue
    contractResults.value = data.contractResults || []
    productResults.value = data.productResults || []
    hasSearched.value = data.hasSearched
    error.value = null
    isLoading.value = false
    if (data.pageState && Date.now() - data.timestamp < 30 * 60 * 1000) {
      currentPage.value = data.pageState.page
      itemsPerPage.value = data.pageState.itemsPerPage
    }
  }
}

onBeforeRouteLeave(() => {
  saveCache()
})

onMounted(() => {
  restoreFromCache()
  const { keyword, type } = route.query
  if (keyword && typeof keyword === 'string') {
    searchValue.value = keyword
    if (type === 'contract' || type === 'product') {
      searchType.value = type
    }
    handleSearch()
  }
})

// 保存缓存
const saveCache = () => {
  const cacheData = {
    searchType: searchType.value,
    searchValue: searchValue.value,
    // contractResults: contractResults.value,
    // productResults: productResults.value,
    // hasSearched: hasSearched.value,
    // pageState: {
    //   page: currentPage.value,
    //   itemsPerPage: itemsPerPage.value
    // },
    timestamp: Date.now()
  }
  // cacheData.productResults.forEach(item => {
  //   item.orderAttrs = "{}"
  // })
  console.log('cacheData', cacheData)
  localStorage.setItem('searchCache', JSON.stringify(cacheData))
}

// 清除缓存
const clearCache = () => {
  localStorage.removeItem('searchCache')
  searchValue.value = ''
  contractResults.value = []
  productResults.value = []
  hasSearched.value = false
}

// 表格列配置
const tableHeaders = computed(() => {
  if (searchType.value === 'product') {
    return [
      { title: '批次', key: 'batch', align: 'center' },
      { title: '产品编号', key: 'no', align: 'center' },
      { title: '产品名称', key: 'name', align: 'center' },
      { title: '数量', key: 'count', align: 'center' },
      { title: '合同编号', key: 'so', align: 'center' },
      { title: '客户名称', key: 'customerName', align: 'center'},
      { title: '项目名称', key: 'project', align: 'center' },
      { title: '图纸', key: 'actions', align: 'center',sortable:false  }
    ]
  }
  return [
    { title: '专案号', key: 'proNo', align: 'start' },
    { title: '合同编号', key: 'so', align: 'start' },
    { title: '客户代码', key: 'customerNo', align: 'start' },
    { title: '客户名称', key: 'customerName', align: 'start' },
    { title: '项目名称', key: 'project', align: 'start' },
    { title: '销售', key: 'business', align: 'start' },
    { title: '图纸', key: 'actions', align: 'center' ,sortable:false }
  ]
})

// 当前搜索结果
const searchResults = computed(() => {
  return searchType.value === 'contract' ? contractResults.value : productResults.value
})

// 切换搜索类型
const handleTypeChange = async (type: 'contract' | 'product') => {
  searchType.value = type
  error.value = null

  // 如果已经搜索过，且切换到的类型还没有结果，则自动搜索
  if (hasSearched.value && searchValue.value && 
    ((type === 'contract' && contractResults.value.length === 0) || 
     (type === 'product' && productResults.value.length === 0))) {
    await handleSearch()
  }
}

// 处理搜索图片
const handleSearchImg = (type: string) => {
  if(type === '1') {
    searchImgType.value = '1'
  } else {
    searchImgType.value = '0'
  }
  showImageSearch.value = true
  isLoadingImgSearch.value = false
  searchImgList.value = []
  localStorage.removeItem('searchImgList')
  localStorage.removeItem('searchImg')
  localStorage.removeItem('searchCache')
  searchResults.value = []
  searchValue.value = ''
  hasSearched.value = false
  currentPage.value = 1
  itemsPerPage.value = 10
}

// 处理图片搜索结果
const handleSearchImgItem = (item: any) => {
  
  // router.push({
  //   path: `/design-draft/${item.productOrderId}/product/${item.productOrderItemId}/design/edit`,
  // })
  const url = `/design-draft/${item.productOrderId}/product/${item.productOrderItemId}/design/see`
  window.open(url, '_blank')
}

// 显示图片搜索组件
const showImageSearch = ref(false)

// 处理图片搜索结果
const handleImageSearchResults = async (searchImgP: string) => {
  console.log('图片搜索结果:', searchImg)
  searchImg.value = searchImgP
  isLoadingImgSearch.value = true
  isLoading.value = true
  showImageSearch.value = false
  try {
    // 调用图片搜索API
    const searchParams = {
      url: searchImgP,
      page: 1,
      pageSize: 100,
      type: searchImgType.value,
      // threshold: 10
    }

    const response = await contractApi.searchImageByImage(searchParams)
    
    if (response.code === 0) {
      searchImgList.value = response.data.records
      localStorage.setItem('searchImgList', JSON.stringify(searchImgList.value))
      localStorage.setItem('searchImg', searchImgP)
      console.log('searchImgList', searchImgList.value)
    } else {
      showError(response.message)
      // error.value = response.message
    }
  } catch (err) {
    console.error('搜索失败:', err)
    // error.value = err.msg
    showError(err.message || err.msg)
  } finally {
    isLoadingImgSearch.value = false
    isLoading.value = false
  }
  // 可以在这里处理搜索结果，比如显示在表格中
}

// 处理选择产品
const handleSelectProduct = (product: any) => {
  console.log('选择的产品:', product)
  // 可以在这里处理产品选择，比如跳转到产品详情页
  showImageSearch.value = false
}

const handleBtnSearch = () => {
  if(localStorage.getItem('searchImgList')) {
    localStorage.removeItem('searchImgList')
    localStorage.removeItem('searchImg')
    localStorage.removeItem('searchCache')
    searchImgList.value = []
    searchImg.value = ''
    currentPage.value = 1
    itemsPerPage.value = 10
  }
  handleSearch()
}
// 搜索处理函数
const handleSearch = async (tip: boolean = true) => {
  if (!searchValue.value.trim()) {
    if(tip) error.value = '请输入搜索关键词'
    return
  }

  error.value = null
  isLoading.value = true
  hasSearched.value = true

  try {
    // 保存当前分页状态
    const currentPageState = {
      page: currentPage.value,
      itemsPerPage: itemsPerPage.value
    }

    // 构建请求数据
    const requestData = {
      page: 1,
      pageSize: 22,
      type: searchType.value === 'contract' ? 1 : 0,
      keyword: searchValue.value.trim(),
      all: 1
    }

    const res = await searchApi.searchOrders(requestData)

    if (res.code === 0) {
      // 保存完整的返回数据
      const results = res.data || []
      if (searchType.value === 'contract') {
        contractResults.value = results.map(item => ({
          ...item,
          attrs: "{}",
          id: item.id,
          so: item.so,
          customerName: item.customerName || item.customer,
          customerNo: item.customerNo,
          project: item.project || '-',
          business: item.business || '-',
          day: item.day
        }))
      } else {
        productResults.value = results.map(item => ({
          ...item, 
          orderAttrs: "{}",
          proNo: item.proNo,
          id: item.id,
          batch: item.batch,
          no: item.no,
          name: item.name || '-',
          count: item.count,
          width: item.width,
          depth: item.depth,
          height: item.height,
          size: item.width || item.depth || item.height ? 
            `${item.width || 0}×${item.depth || 0}×${item.height || 0}` : '-',
          so: item.order?.so || '-',
          customerName: item.order?.customerName || item.order?.customer || '-',
          project: item.order?.project || '-'
        }))
      }

      // 恢复分页状态
      currentPage.value = currentPageState.page
      itemsPerPage.value = currentPageState.itemsPerPage

      saveCache()
    } else {
      error.value = res.msg || '搜索失败'
    }
  } catch (err: any) {
    console.error('搜索失败:', err)
    error.value = err.message || '搜索失败'
  } finally {
    isLoading.value = false
  }
}

// 处理查看图纸
const handleViewDrawings = (item: any) => {
  // router.push({
  //   path: `/contract/${item.order?.id}/product/${item.id}/images`
  // })
  const url = `/contract/${item.order?.id}/product/${item.id}/images`
  window.open(url, '_blank')
}

const toAllDraws = (item: any) => {
  const url = `/contract/${item.id}/contract-draws`
  window.open(url, '_blank')
}

const toOtherDraws = (item: any) => {
  const url = `/contract/${item.id}/inventory`
  window.open(url, '_blank')
}

// 处理查看产品
const handleViewProducts = (item: any) => {
  // router.push({
  //   path: `/contract/${item.id}/products`,
  //   query: {
  //     page: 1,  // 默认第一页
  //     size: 10  // 每页显示10条
  //   }
  // })
  const url = `/contract/${item.id}/products?query={page:1,size:10}`
  window.open(url, '_blank')
}


// 保存分页状态
const savePageState = () => {
  const pageState = {
    page: currentPage.value,
    itemsPerPage: itemsPerPage.value,
  }
  localStorage.setItem('searchPageState', JSON.stringify(pageState))
}

// 从 URL 参数初始化搜索
onMounted(() => {
  const searchImgListP = localStorage.getItem('searchImgList')
  const searchImgP = localStorage.getItem('searchImg')
  console.log('searchImgListP', searchImgListP)
  if(searchImgP){
    searchType.value = 'image'
  }
  if(searchType.value === 'contract') {
    localStorage.removeItem('searchImgList')
    localStorage.removeItem('searchImg')
  }
  if(searchType.value === 'image') {
    if (searchImgListP) {
      searchImgList.value = JSON.parse(searchImgListP)
    }
    if (searchImgP) {
      searchImg.value = searchImgP
    }
  }else{
    localStorage.removeItem('searchImgList')
    localStorage.removeItem('searchImg')
  }
  const { keyword, type } = route.query
  if (keyword && typeof keyword === 'string') {
    searchValue.value = keyword
    if (type === 'contract' || type === 'product') {
      searchType.value = type
    }
    handleSearch()
  }
  handleSearch(false)
})

//页面显示


// 监听路由变化
watch(
  () => route.path,
  (query) => {
    // const { keyword, type } = query
    // if (keyword && typeof keyword === 'string') {
    //   searchValue.value = keyword
    //   if (type === 'contract' || type === 'product') {
    //     searchType.value = type
    //   }
    //   handleSearch()
    // }

    handleSearch() 
  }
)
</script>

<style scoped lang="scss">
.search-page {
  padding: 24px;
  max-width: 1400px;
  margin: 0 auto;
}

.search-container {
  margin-bottom: 24px;
  width: 100%;
}

.search-type-toggle {
  margin-bottom: 16px;
  display: flex;
  justify-content: center;

  .button-group {
    border-radius: 8px;
    background-color: #333;
    overflow: hidden;
  }

  .toggle-button {
    min-width: 120px;
    border-radius: 8px;
    font-weight: 500;
    color: #999 !important;

    &.v-btn--active {
      background: linear-gradient(45deg, #E34C65, #D2475D) !important;
      color: white !important;
    }
  }
}

.search-input {
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
}

.search-input :deep(.v-field__input) {
  color: white;
}

.search-input :deep(.v-field__field) input {
  border: 1px solid rgba(255, 255, 255, 0);
  border-radius: 4px;
}

.search-input :deep(.v-field__field) input:focus {
  border: 1px solid rgba(255, 255, 255, 0.1);
   border-radius: 4px;
}

.search-input :deep(.v-field__outline) {
  display: none;
}


.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 48px 0;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  background-color: rgba(255, 255, 255, 0.02);
  border-radius: 8px;
}

.error-alert {
  margin-bottom: 24px;
  width: 100%;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
}

.search-table {
  margin-top: 24px;
  width: 100%;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  overflow: hidden;
}

.search-table :deep(.v-data-table__wrapper) {
  border-radius: 8px;
}

.search-table :deep(th) {
  color: rgba(255, 255, 255, 0.7) !important;
  font-weight: 500 !important;
  font-size: 0.875rem !important;
  background-color: rgba(255, 255, 255, 0.02) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
}

.search-table :deep(td) {
  color: rgba(255, 255, 255, 0.9) !important;
  font-size: 0.875rem !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;
}

.search-table :deep(tr:hover) {
  background-color: rgba(255, 255, 255, 0.05) !important;
}
 
.search-table :deep(th) {
  white-space: nowrap;
}

.action-btn {
  margin: 0 4px;
  min-width: 80px;
  letter-spacing: 0.5px;
  background: linear-gradient(315deg, #E34C65, #D2475D) !important;
  color: white !important;
  border: none !important;
  box-shadow: 0 2px 8px rgba(227, 76, 101, 0.3) !important;
}

.action-btn:hover {
  box-shadow: 0 4px 12px rgba(227, 76, 101, 0.4) !important;
}

.action-btn:active {
  box-shadow: 0 1px 4px rgba(227, 76, 101, 0.2) !important;
}

.action-btn:disabled {
  background: linear-gradient(315deg, #E34C65, #D2475D) !important;
  box-shadow: none !important;
  opacity: 0.7;
}

.empty-state {
  text-align: center;
  padding: 48px 0;
  color: rgba(255, 255, 255, 0.7);
  background-color: rgba(255, 255, 255, 0.02);
  border-radius: 8px;
  width: 100%;
  max-width: 1400px;
  margin: 24px auto 0;
}

.empty-state .v-icon {
  opacity: 0.5;
  margin-bottom: 16px;
}

.empty-state .text-h6 {
  font-size: 1.1rem;
  font-weight: 500;
  margin-bottom: 8px;
}

.empty-state .text-subtitle-1 {
  font-size: 0.875rem;
  opacity: 0.7;
}

/* 分页器样式 */
.search-table :deep(.v-data-table-footer) {
  background-color: rgba(255, 255, 255, 0.02);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.search-table :deep(.v-data-table-footer__items-per-page),
.search-table :deep(.v-data-table-footer__info) {
  color: rgba(255, 255, 255, 0.7);
}

.search-table :deep(.v-data-table-footer__items-per-page .v-select__selection),
.search-table :deep(.v-data-table-footer__items-per-page .v-select__append-inner) {
  color: rgba(255, 255, 255, 0.7);
}

.search-table :deep(.v-data-table-footer__items-per-page .v-field) {
  border-color: rgba(255, 255, 255, 0.1);
}

/* 分页切换按钮样式 */
.search-table :deep(.v-data-table-footer__pagination .v-btn) {
  color: rgba(255, 255, 255, 0.7);
  border-radius: 50% !important;
  min-width: 36px !important;
  width: 36px !important;
  height: 36px !important;
  padding: 0 !important;
}

.search-table :deep(.v-data-table-footer__pagination .v-btn--disabled) {
  color: rgba(255, 255, 255, 0.3) !important;
}

.search-table :deep(.v-data-table-footer__pagination .v-btn--active) {
  background-color: #E34C65 !important;
  color: white !important;
}

/* 分页按钮样式 */
:deep(.v-data-table-footer) {
  background-color: #2B2D33 !important;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.7) !important;

  .v-btn {
    &:not(.v-btn--disabled) {
      background: var(--primary-gradient) !important;
      color: white !important;
      border: none !important;
      box-shadow: 0 2px 8px rgba(227, 76, 101, 0.3) !important;

      &:hover {
        box-shadow: 0 4px 12px rgba(227, 76, 101, 0.4) !important;
      }
      
      &:active {
        box-shadow: 0 1px 4px rgba(227, 76, 101, 0.2) !important;
      }
    }
    
    &.v-btn--disabled {
      opacity: 0.5;
      background: linear-gradient(315deg, #E34C65, #D2475D) !important;
      color: rgba(255, 255, 255, 0.5) !important;
      box-shadow: none !important;
    }
  }
  
  .v-data-table-footer__items-per-page,
  .v-data-table-footer__info {
    color: rgba(255, 255, 255, 0.7);
  }
}

.search-img-item {
  width: 250px;
  height: 250px;
  margin-right: 25px;
  margin-bottom: 25px;
  border-radius: 0px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
}

.search-img-item:nth-child(5n) {
  margin-right: 0;
}

.search-img-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.search-img-item .search-img-item-label {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 100px;
  height: 28px;
  background: #2B2D33;
  border-radius: 1px 1px 1px 1px;
  opacity: 0.8;
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
}

.search-img-area {
  border: 2px dashed rgba(255,255,255,0.12);
  border-radius: 8px;
  text-align: center;
  cursor: pointer;
  padding: 32px 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(255, 255, 255, 0.02);
}
.search-img-area:hover {
  border-color: var(--v-primary-base);
  background: rgba(var(--v-primary-base), 0.05);
}
</style>
